export const SIZES = {
  H1: 28,
  H2: 24,
  H3: 18,
  H4: 14,
  bodyLg: 16,
  bodyMd: 14,
  bodySm: 12,
};
